module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c01_r1"
    }
  }, [_vm._v("chapter 1 - Natural Born Killers")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2 - The Boston Strangler")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3 - Australian Spree Killers")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 4 - Sniper in the Tower")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5 - The Zodiac Killer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6 - The Family")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7 - The Moors Murderers")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 8 - Ted Bundy")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9 - The Yorkshire Ripper")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 10 - Son of Sam")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 11 - Dennis Nilsen")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 12 - The Night Stalker")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 13 - Hungerford")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14 - Jeffrey Dahmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15 - The House of Horrors")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16 - Doctor Death")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 17 - Columbine")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Ulysses Press")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/nige_9781569759394_oeb_cop_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d9d8a58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nige_9781569759394_oeb_toc_r1.vue
// module id = 60
// module chunks = 0